import React, { useState } from "react";

import {
  ArrowLeft,
  ShieldCheck,
  BadgeDollarSign,
  Home,
  Car,
  HeartPulse,
  FileCheck,
  BellRing,
  CheckCircle2,
  ArrowRight,
  Landmark,
} from "lucide-react";

import { useNavigate }
from "react-router-dom";

import "../Styles/Insurance.css";

import PolicyRenewalModal
from "../components/PolicyRenewalModal";

const insuranceTypes = [

  {
    icon: Car,
    title: "Motor Insurance",
    desc:
      "Vehicle insurance policies and renewals.",
  },

  {
    icon: Home,
    title: "Fire Insurance",
    desc:
      "Property and home insurance protection.",
  },

  {
    icon: HeartPulse,
    title: "Life Insurance",
    desc:
      "Reliable life insurance solutions.",
  },

  {
    icon: Landmark,
    title: "General Insurance",
    desc:
      "Tailored insurance services for clients.",
  },

];

const Insurance = () => {

  const navigate =
    useNavigate();

  const [showRenewalForm,
    setShowRenewalForm] =
      useState(false);

  return (

    <div className="modern-insurance-page">

      {/* HERO */}
      <section className="modern-insurance-hero">

        <div className="modern-insurance-overlay" />

        <div className="modern-insurance-content">

          <button
            className="modern-insurance-back-btn"
            onClick={() =>
              navigate("/services")
            }
          >

            <ArrowLeft size={18} />
            Back To Services

          </button>

          <div className="modern-insurance-badge">
            INSURANCE SERVICES
          </div>

          <h1 className="modern-insurance-heading">
            Protection You
            <span> Can Trust.</span>
          </h1>

          <p className="modern-insurance-text">
            RCS, in partnership with
            Apex Insurance Brokers,
            delivers reliable insurance
            services and hassle-free
            renewals across Guyana.
          </p>

        </div>

      </section>

      {/* HIGHLIGHTS */}
      <section className="modern-insurance-highlights">

        {insuranceTypes.map(
          (item, index) => {

          const Icon =
            item.icon;

          return (

            <div
              className="modern-insurance-highlight-card"
              key={index}
            >

              <div className="modern-insurance-icon">
                <Icon size={32} />
              </div>

              <h3>
                {item.title}
              </h3>

              <p>
                {item.desc}
              </p>

            </div>
          );
        })}

      </section>

      {/* MAIN */}
      <section className="modern-insurance-main">

        {/* LEFT */}
        <div className="modern-insurance-card">

          <div className="modern-insurance-card-header">

            <div className="modern-insurance-header-icon">

              <ShieldCheck size={30} />

            </div>

            <div>

              <h2>
                Insurance Solutions
              </h2>

              <p>
                Reliable coverage and renewals.
              </p>

            </div>

          </div>

          <p className="modern-insurance-paragraph">

            RCS operates as a sub-office
            of Apex Insurance Brokers,
            headquartered in Georgetown,
            Guyana.

          </p>

          <p className="modern-insurance-paragraph">

            We assist with renewing
            current policies and effecting
            new policies for motor,
            fire, life and general
            insurance across all insurance
            companies in Guyana.

          </p>

          <div className="modern-insurance-note">

            <CheckCircle2 size={20} />

            Hassle-free insurance
            renewals tailored to
            your individual needs.

          </div>

        </div>

        {/* RIGHT */}
        <div className="modern-insurance-card">

          <div className="modern-insurance-card-header">

            <div className="modern-insurance-header-icon green">

              <BellRing size={30} />

            </div>

            <div>

              <h2>
                Did You Know?
              </h2>

              <p>
                Avoid policy lapses.
              </p>

            </div>

          </div>

          <div className="modern-insurance-alert">

            <FileCheck size={20} />

            RCS handles policy submissions,
            renewal reminders and insurer
            coordination on your behalf.

          </div>

          <div className="modern-insurance-alert">

            <CheckCircle2 size={20} />

            Policies are renewed ahead
            of expiration, helping clients
            avoid unnecessary costs and delays.

          </div>

          {/* CTA */}

          <div className="modern-renewal-box">

            <div className="modern-renewal-icon">

              <BadgeDollarSign size={34} />

            </div>

            <h3>
              Have A Policy To Renew?
            </h3>

            <p>
              Enjoy fast and hassle-free
              insurance renewal services
              directly through RCS.
            </p>

            <button
              className="modern-renewal-btn"
              onClick={() =>
                setShowRenewalForm(true)
              }
            >

              Renew A Policy

              <ArrowRight size={18} />

            </button>

          </div>

        </div>

      </section>

      {showRenewalForm && (

        <PolicyRenewalModal
          onClose={() =>
            setShowRenewalForm(false)
          }
        />
      )}

    </div>
  );
};

export default Insurance;